import { Avatar, Box, Typography } from "@mui/material";
import gift_iconUrl from "@/assets/icons/fleet-inquiry/gift.svg";
import { labelIconStyles, labelStyles } from "./styles";

interface IProps {
  title: string;
  subtitle: string;
  withHeader?: boolean;
}
const FormTitle: React.FC<IProps> = ({
  title,
  subtitle,
  withHeader = false,
}) => {
  return (
    <Box
      textAlign="center"
      pb={{
        xs: withHeader ? 4 : 5,
        md: withHeader ? 6 : 2.75,
        lg: withHeader ? 7.5 : 2.75,
      }}
    >
      {withHeader && (
        <>
          <Typography
            variant="h4"
            gap={1}
            sx={labelStyles}
            mb={{ xs: 2, md: 3 }}
          >
            <Avatar src={gift_iconUrl} sx={labelIconStyles} />
            Send Fleet Inquiry
          </Typography>
        </>
      )}

      <Typography variant="h2" mb={{ xs: 2, md: 1 }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        fontWeight={{ xs: 500, md: 600 }}
        maxWidth={withHeader ? "auto" : 474}
        mx="auto"
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default FormTitle;
